module.exports = __webpack_public_path__ + "img/cel-web.efb41cbe.png";